import { ReservationStatusEnum } from "../../enums/reservation-status.enum";

export class RegistrationPaginationHelperModel {
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public status: number = ReservationStatusEnum.Pending;
  public venueId: string;
  [param: string]: string | number;
}
